import { AlertModalEntry } from '../modal-manager.state';
import { ModalResult } from '../modal-manager.types';
import { ModalFrame } from './ModalFrame';

type AlertModalProps = {
  entry: AlertModalEntry;
  stackIndex: number;
  isTopmost: boolean;
  onResolve: (modalId: string, result: { result: ModalResult }) => void;
};

export const AlertModal = ({ entry, stackIndex, isTopmost, onResolve }: AlertModalProps) => {
  const confirm = () => onResolve(entry.modalId, { result: ModalResult.Confirm });
  const close = () => onResolve(entry.modalId, { result: ModalResult.Closed });

  return (
    <ModalFrame
      title={entry.options.title}
      size={entry.options.size}
      stackIndex={stackIndex}
      isTopmost={isTopmost}
      onClose={close}
      renderFooter={entry.options.renderFooter?.({ confirm, close })}
      defaultFooter={
        entry.options.buttonProps
          ? {
              confirmButton: { ...entry.options.buttonProps, onClick: confirm },
            }
          : undefined
      }
    >
      {entry.options.renderBody()}
    </ModalFrame>
  );
};
